module.exports = __webpack_public_path__ + "img/face-laugh-beam.8d44cb68.svg";